import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

const DamDescription = ({ year, capacity, raised, lang }) => {
  return (
    <>
      {year && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en' ? 'Year of construction' : 'سنة البناء'}
          </div>
          <div className="value">{year}</div>
        </ResourceDetailsBlock>
      )}
      {raised && (
        <ResourceDetailsBlock>
          <span className="label">
            {lang === 'en' ? `Year Raised` : `سنة التوسعة`}
          </span>
          <span className="value">{raised}</span>
        </ResourceDetailsBlock>
      )}
      {capacity && (
        <ResourceDetailsBlock>
          <span className="label">
            {lang === 'en' ? 'Capacity (MCM)' : 'السعة (مليون م٣)'}
          </span>
          <span className="value">{capacity}</span>
        </ResourceDetailsBlock>
      )}
    </>
  )
}

DamDescription.propTypes = {
  id: PropTypes.string,
  capacity: PropTypes.string,
  raised: PropTypes.string,
  year: PropTypes.string,
  lang: PropTypes.string
}

export default DamDescription
